import React from 'react'
import { TextField,Typography,Box,Grid,Slider } from '@mui/material'
import { Height } from '@mui/icons-material';
import useEmailEditorStore from '../../utilities/emailEditorStore';
function SpacerBlockProperties({blockId}) {
  const { getBlockById, updateBlockProperties } = useEmailEditorStore();
  
  // Get the current block data from the store
  const block = getBlockById(blockId);
  
  if (!block) {
    return <Typography>Block not found</Typography>;
  }
  
  // Provide default properties if properties is undefined
  const properties = block.properties || {};

  // Generic property change handler
  const handlePropertyChange = (propertyName, value) => {
    updateBlockProperties(blockId, { [propertyName]: value });
  };
  return (
    <>
           
             <Box>
                  <Typography variant="body2" gutterBottom>
                                        Height
                                      </Typography>
                                      <Grid container spacing={2} sx={{ alignItems: 'center' }}>
                                        <Grid>
                                         <Height/>
                                        </Grid>
                                        <Grid size="grow">
                                          <Slider
                                            value={properties.height || 16}
                                            onChange={(e, value) => handlePropertyChange('height', value)}
                                            aria-labelledby="input-slider-height"
                                            step={1}
                                            marks
                                            max={150}
                                          />
                                        </Grid>
                                        <Grid>
                                          <Typography variant="body2" gutterBottom>
                                            {properties.height || 16} px
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Box>
          </>
  )
}

export default SpacerBlockProperties